/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Authentication API
 * This Authentification API for Kazaar
 * OpenAPI spec version: 1.3.2
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiKeyLoginDto,
  AuthControllerCreateCustomToken200,
  CreateCustomTokenDto,
  GetSSOProvider200,
  GetSSOProviderParams,
  Login200,
  LoginDto,
  LoginWithAPIKey200,
  RefreshToken200,
  RefreshToken404,
  RefreshTokenDto,
  ResetPasswordDto,
  UserHasPassword200,
  UserHasPasswordDto
} from '../../schemas';

import { customFetch } from '../../../../../clients/customInstance';
import type { ErrorType } from '../../../../../clients/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Login with API key
 * @summary Login with API key
 */
export type loginWithAPIKeyResponse200 = {
  data: LoginWithAPIKey200
  status: 200
}

export type loginWithAPIKeyResponseSuccess = (loginWithAPIKeyResponse200) & {
  headers: Headers;
};
;

export type loginWithAPIKeyResponse = (loginWithAPIKeyResponseSuccess)

export const getLoginWithAPIKeyUrl = () => {


  

  return `/auth/api-key-login`
}

export const loginWithAPIKey = async (apiKeyLoginDto: ApiKeyLoginDto, options?: RequestInit): Promise<loginWithAPIKeyResponse> => {
  
  return customFetch<loginWithAPIKeyResponse>(getLoginWithAPIKeyUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      apiKeyLoginDto,)
  }
);}
  



export const getLoginWithAPIKeyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginWithAPIKey>>, TError,{data: ApiKeyLoginDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof loginWithAPIKey>>, TError,{data: ApiKeyLoginDto}, TContext> => {

const mutationKey = ['loginWithAPIKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginWithAPIKey>>, {data: ApiKeyLoginDto}> = (props) => {
          const {data} = props ?? {};

          return  loginWithAPIKey(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type LoginWithAPIKeyMutationResult = NonNullable<Awaited<ReturnType<typeof loginWithAPIKey>>>
    export type LoginWithAPIKeyMutationBody = ApiKeyLoginDto
    export type LoginWithAPIKeyMutationError = ErrorType<unknown>

    /**
 * @summary Login with API key
 */
export const useLoginWithAPIKey = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginWithAPIKey>>, TError,{data: ApiKeyLoginDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof loginWithAPIKey>>,
        TError,
        {data: ApiKeyLoginDto},
        TContext
      > => {
      return useMutation(getLoginWithAPIKeyMutationOptions(options), queryClient);
    }
    /**
 * User login
 * @summary User login
 */
export type loginResponse200 = {
  data: Login200
  status: 200
}

export type loginResponseSuccess = (loginResponse200) & {
  headers: Headers;
};
;

export type loginResponse = (loginResponseSuccess)

export const getLoginUrl = () => {


  

  return `/auth/login`
}

export const login = async (loginDto: LoginDto, options?: RequestInit): Promise<loginResponse> => {
  
  return customFetch<loginResponse>(getLoginUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      loginDto,)
  }
);}
  



export const getLoginMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginDto}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: LoginDto}> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginDto
    export type LoginMutationError = ErrorType<unknown>

    /**
 * @summary User login
 */
export const useLogin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: LoginDto},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options), queryClient);
    }
    /**
 * Refresh token
 * @summary Refresh token
 */
export type refreshTokenResponse200 = {
  data: RefreshToken200
  status: 200
}

export type refreshTokenResponse404 = {
  data: RefreshToken404
  status: 404
}

export type refreshTokenResponseSuccess = (refreshTokenResponse200) & {
  headers: Headers;
};
export type refreshTokenResponseError = (refreshTokenResponse404) & {
  headers: Headers;
};

export type refreshTokenResponse = (refreshTokenResponseSuccess | refreshTokenResponseError)

export const getRefreshTokenUrl = () => {


  

  return `/auth/refresh-token`
}

export const refreshToken = async (refreshTokenDto: RefreshTokenDto, options?: RequestInit): Promise<refreshTokenResponse> => {
  
  return customFetch<refreshTokenResponse>(getRefreshTokenUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      refreshTokenDto,)
  }
);}
  



export const getRefreshTokenMutationOptions = <TError = ErrorType<RefreshToken404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshToken>>, TError,{data: RefreshTokenDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshToken>>, TError,{data: RefreshTokenDto}, TContext> => {

const mutationKey = ['refreshToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshToken>>, {data: RefreshTokenDto}> = (props) => {
          const {data} = props ?? {};

          return  refreshToken(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof refreshToken>>>
    export type RefreshTokenMutationBody = RefreshTokenDto
    export type RefreshTokenMutationError = ErrorType<RefreshToken404>

    /**
 * @summary Refresh token
 */
export const useRefreshToken = <TError = ErrorType<RefreshToken404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshToken>>, TError,{data: RefreshTokenDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshToken>>,
        TError,
        {data: RefreshTokenDto},
        TContext
      > => {
      return useMutation(getRefreshTokenMutationOptions(options), queryClient);
    }
    /**
 * Get SSO Provider
 * @summary Get SSO Provider operation
 */
export type getSSOProviderResponse200 = {
  data: GetSSOProvider200
  status: 200
}

export type getSSOProviderResponseSuccess = (getSSOProviderResponse200) & {
  headers: Headers;
};
;

export type getSSOProviderResponse = (getSSOProviderResponseSuccess)

export const getGetSSOProviderUrl = (params: GetSSOProviderParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/get-sso-provider?${stringifiedParams}` : `/auth/get-sso-provider`
}

export const getSSOProvider = async (params: GetSSOProviderParams, options?: RequestInit): Promise<getSSOProviderResponse> => {
  
  return customFetch<getSSOProviderResponse>(getGetSSOProviderUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetSSOProviderQueryKey = (params?: GetSSOProviderParams,) => {
    return [
    `/auth/get-sso-provider`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetSSOProviderQueryOptions = <TData = Awaited<ReturnType<typeof getSSOProvider>>, TError = ErrorType<unknown>>(params: GetSSOProviderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSSOProvider>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSSOProviderQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSSOProvider>>> = ({ signal }) => getSSOProvider(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSSOProvider>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSSOProviderQueryResult = NonNullable<Awaited<ReturnType<typeof getSSOProvider>>>
export type GetSSOProviderQueryError = ErrorType<unknown>


export function useGetSSOProvider<TData = Awaited<ReturnType<typeof getSSOProvider>>, TError = ErrorType<unknown>>(
 params: GetSSOProviderParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSSOProvider>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSSOProvider>>,
          TError,
          Awaited<ReturnType<typeof getSSOProvider>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSSOProvider<TData = Awaited<ReturnType<typeof getSSOProvider>>, TError = ErrorType<unknown>>(
 params: GetSSOProviderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSSOProvider>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSSOProvider>>,
          TError,
          Awaited<ReturnType<typeof getSSOProvider>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSSOProvider<TData = Awaited<ReturnType<typeof getSSOProvider>>, TError = ErrorType<unknown>>(
 params: GetSSOProviderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSSOProvider>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get SSO Provider operation
 */

export function useGetSSOProvider<TData = Awaited<ReturnType<typeof getSSOProvider>>, TError = ErrorType<unknown>>(
 params: GetSSOProviderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSSOProvider>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSSOProviderQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * User has password
 * @summary User has password
 */
export type userHasPasswordResponse200 = {
  data: UserHasPassword200
  status: 200
}

export type userHasPasswordResponseSuccess = (userHasPasswordResponse200) & {
  headers: Headers;
};
;

export type userHasPasswordResponse = (userHasPasswordResponseSuccess)

export const getUserHasPasswordUrl = () => {


  

  return `/auth/has-password`
}

export const userHasPassword = async (userHasPasswordDto: UserHasPasswordDto, options?: RequestInit): Promise<userHasPasswordResponse> => {
  
  return customFetch<userHasPasswordResponse>(getUserHasPasswordUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userHasPasswordDto,)
  }
);}
  



export const getUserHasPasswordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userHasPassword>>, TError,{data: UserHasPasswordDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof userHasPassword>>, TError,{data: UserHasPasswordDto}, TContext> => {

const mutationKey = ['userHasPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userHasPassword>>, {data: UserHasPasswordDto}> = (props) => {
          const {data} = props ?? {};

          return  userHasPassword(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UserHasPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof userHasPassword>>>
    export type UserHasPasswordMutationBody = UserHasPasswordDto
    export type UserHasPasswordMutationError = ErrorType<unknown>

    /**
 * @summary User has password
 */
export const useUserHasPassword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userHasPassword>>, TError,{data: UserHasPasswordDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userHasPassword>>,
        TError,
        {data: UserHasPasswordDto},
        TContext
      > => {
      return useMutation(getUserHasPasswordMutationOptions(options), queryClient);
    }
    export type authControllerCreateCustomTokenResponse200 = {
  data: AuthControllerCreateCustomToken200
  status: 200
}

export type authControllerCreateCustomTokenResponseSuccess = (authControllerCreateCustomTokenResponse200) & {
  headers: Headers;
};
;

export type authControllerCreateCustomTokenResponse = (authControllerCreateCustomTokenResponseSuccess)

export const getAuthControllerCreateCustomTokenUrl = () => {


  

  return `/auth/create-custom-token`
}

export const authControllerCreateCustomToken = async (createCustomTokenDto: CreateCustomTokenDto, options?: RequestInit): Promise<authControllerCreateCustomTokenResponse> => {
  
  return customFetch<authControllerCreateCustomTokenResponse>(getAuthControllerCreateCustomTokenUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCustomTokenDto,)
  }
);}
  



export const getAuthControllerCreateCustomTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerCreateCustomToken>>, TError,{data: CreateCustomTokenDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerCreateCustomToken>>, TError,{data: CreateCustomTokenDto}, TContext> => {

const mutationKey = ['authControllerCreateCustomToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerCreateCustomToken>>, {data: CreateCustomTokenDto}> = (props) => {
          const {data} = props ?? {};

          return  authControllerCreateCustomToken(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerCreateCustomTokenMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerCreateCustomToken>>>
    export type AuthControllerCreateCustomTokenMutationBody = CreateCustomTokenDto
    export type AuthControllerCreateCustomTokenMutationError = ErrorType<unknown>

    export const useAuthControllerCreateCustomToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerCreateCustomToken>>, TError,{data: CreateCustomTokenDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerCreateCustomToken>>,
        TError,
        {data: CreateCustomTokenDto},
        TContext
      > => {
      return useMutation(getAuthControllerCreateCustomTokenMutationOptions(options), queryClient);
    }
    /**
 * Reset password
 * @summary Reset password
 */
export type resetPasswordResponse204 = {
  data: void
  status: 204
}

export type resetPasswordResponseSuccess = (resetPasswordResponse204) & {
  headers: Headers;
};
;

export type resetPasswordResponse = (resetPasswordResponseSuccess)

export const getResetPasswordUrl = () => {


  

  return `/auth/reset-password`
}

export const resetPassword = async (resetPasswordDto: ResetPasswordDto, options?: RequestInit): Promise<resetPasswordResponse> => {
  
  return customFetch<resetPasswordResponse>(getResetPasswordUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      resetPasswordDto,)
  }
);}
  



export const getResetPasswordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordDto}, TContext> => {

const mutationKey = ['resetPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: ResetPasswordDto}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordDto
    export type ResetPasswordMutationError = ErrorType<unknown>

    /**
 * @summary Reset password
 */
export const useResetPassword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {data: ResetPasswordDto},
        TContext
      > => {
      return useMutation(getResetPasswordMutationOptions(options), queryClient);
    }
    